export default function () {
  return [{
    title: '',
    items: [{
      title: 'Dashboard',
      to: '/analytics',
      htmlBefore: '<i class="material-icons">&#xE917;</i>',
      htmlAfter: '',
    },
    {
      title: 'Campaigns',
      to: '/campaigns',
      htmlBefore: '<i class="material-icons">&#xE8E1;</i>',
      htmlAfter: '',
    },
    {
      title: 'Social Inbox',
      to: '/social-inbox',
      htmlBefore: '<i class="material-icons">&#xe0b7;</i>',
      htmlAfter: '',
    },
      // {
      //   title: 'Manage Leads',
      //   to: '/leads',
      //   htmlBefore: '<i class="material-icons">&#xE7Fb;</i>',
      //   htmlAfter: '',
      // },
      // {
      //   title: 'Marketing Tips',
      //   to: '/tips',
      //   htmlBefore: '<i class="material-icons">&#xe6dd;</i>',
      //   htmlAfter: '',
      // },
      //     
      // {
      //   title: 'Account',
      //   to: '/edit-user-profile',
      //   htmlBefore: '<i class="material-icons">&#xE7FD;</i>',
      //   htmlAfter: '',
      // },
      // {
      //   title: 'Team',
      //   to: '/team',
      //   htmlBefore: '<i class="material-icons">&#xE7Fb;</i>',
      //   htmlAfter: '',
      // },
      // {
      //   title: 'Plan',
      //   to: '/plan',
      //   htmlBefore: '<i class="material-icons">&#xE870;</i>',
      //   htmlAfter: '',
      // }
    ]
  },
  ];
}
